import PropTypes from 'prop-types';

// The one place the terms / SMS / marketing consent wording lives. Used by
// the onboarding form, the account consent gate and the Communication
// Preferences page so the three never drift apart.
//
// Bump CONSENT_VERSION whenever any of this wording changes; it is stored on
// every consent ledger row so a dispute can show which wording the customer
// saw. SMS and marketing stay distinct on purpose: the SMS box allows account
// texts and carries the carrier disclaimer; marketing by text needs both.
export const CONSENT_VERSION = '2026-10-02.1';

export const GATE_TITLE = 'Before you continue';
export const GATE_INTRO =
  'Please accept our Terms and Privacy Policy to keep using your account. Text and email preferences are optional.';
export const SELECT_ALL_LABEL = 'Select all';
export const REQUIRED_BADGE = 'Required';
export const PREFERENCES_FOOTER =
  'You can change your text and email preferences anytime in your account.';

export const TERMS_LABEL = 'Terms and Conditions';
export const TERMS_BEFORE = "I agree to Retainer Club's ";
export const TERMS_AND = ' and ';
export const TERMS_AFTER =
  ", and I'm at least 18 and the account holder or a parent or guardian managing this account.";

export const SMS_LABEL = 'Account text messages';
export const SMS_DESCRIPTION = 'Text me about my account, orders and shipments.';
export const SMS_DISCLAIMER =
  'Msg frequency varies. Msg & data rates may apply. Reply STOP to opt out, HELP for help.';

export const MARKETING_LABEL = 'Offers and news';
export const MARKETING_DESCRIPTION =
  'Be first to hear about exclusive member discounts, new products, and smile tips by email and text.';
export const MARKETING_DISCLAIMER =
  "Consent isn't required to purchase. Unsubscribe anytime.";

const LINK_CLASS = 'text-rcprimary-400 hover:text-rcprimary-300';

// The terms sentence with the two policy links. onOpenPolicy receives
// 'terms' or 'privacy'.
export function TermsDescription({ onOpenPolicy }) {
  return (
    <span>
      {TERMS_BEFORE}
      <button
        type="button"
        className={LINK_CLASS}
        onClick={() => onOpenPolicy('terms')}
      >
        Terms and Conditions
      </button>
      {TERMS_AND}
      <button
        type="button"
        className={LINK_CLASS}
        onClick={() => onOpenPolicy('privacy')}
      >
        Privacy Policy
      </button>
      {TERMS_AFTER}
    </span>
  );
}

TermsDescription.propTypes = {
  onOpenPolicy: PropTypes.func.isRequired,
};

export function SmsDescription() {
  return (
    <span>
      {SMS_DESCRIPTION}
      <span className="mt-3 block text-black/50">{SMS_DISCLAIMER}</span>
    </span>
  );
}

export function MarketingDescription() {
  return (
    <span>
      {MARKETING_DESCRIPTION}
      <span className="mt-3 block text-black/50">{MARKETING_DISCLAIMER}</span>
    </span>
  );
}
